
import { Box, Card,  Button, Typography, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { ClockAlert, Asterisk, Ellipsis } from "lucide-react";
import { useParams } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ExaminationMiniDashboard = () => {

  const { Examtype } = useParams();
  const navigate = useNavigate();
  const IconWrapper = ({ icon, color, customStyles }) => (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: customStyles?.size || "40px", // Customizable size
        height: customStyles?.size || "40px",
        borderRadius: "50%",
        backgroundColor: customStyles?.bgColor || `${color}20`, // Custom or default light background
        color: customStyles?.iconColor || color, // Custom icon color if needed
        fontSize: customStyles?.fontSize || "24px", // Custom font size if needed
        ...customStyles?.extraStyles, // Additional custom styles
      }}
    >
      {icon}
    </Box>
  );

  const data = [
    {
      id: "01",
      title: "Examination Schedule",
      icon: <ClockAlert />,
      color: "#6A1B9A",
      route: `/Unit1ExaminationScheduleList/${Examtype}`,
      iconStyles: { size: "45px", bgColor: "#F3E5F5", fontSize: "26px" },
    },
    
    {
      id: "02",
      title: "HallTicket",
      icon: <Ellipsis />,
      color: "#00897B",
      route: `/Hallticketslist/${Examtype}`,
      iconStyles: { size: "40px", bgColor: "#E0F2F1", fontSize: "24px" },
    },
    {
      id: "03",
      title: "Results",
      icon: <Asterisk />,
      color: "#0078D7",
      route: `/Unit1ExaminationResultList/${Examtype}`,
      iconStyles: { size: "50px", bgColor: "#E3F2FD", fontSize: "28px" },
    },
  ];
  const handleNavigation = (route) => {
    if (route) {
      navigate(route);
    }
  };

  return (
    <Card
      style={{
        height: "85vh",
        margin: "5.3% 1% 1%",
        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
        backgroundColor: "#ffffff",
        paddingTop: "10px",
      }}
    >

<Box
  display="flex"
  alignItems="center"
  justifyContent="space-between"
  sx={{ marginBottom: 2 }}
>

        {/* Left side: Back button + heading */}
        <Box display="flex" alignItems="center">

        <IconButton
          onClick={() => navigate(-1)}
          sx={{ color: "#2e2a54" }}
        >
          <KeyboardBackspaceIcon fontSize="medium" />
        </IconButton>
        <Typography variant="h4" component="h3" sx={{ fontWeight: "bold" }}>
          {Examtype} Examination Schedule
        </Typography>
      </Box>
</Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <Card
          sx={{
            width: "80%",
            padding: "40px",
            borderRadius: "16px",
            boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
            display: "flex", // Make the layout horizontal
            flexDirection: "row", // Align items side-by-side
            alignItems: "center",
            justifyContent: "space-between", // Adjust spacing
            backgroundColor: "white",
          }}
        >
          {/* Left Side: Circle */}
          <Box
            sx={{
              width: "200px",
              height: "200px",
              borderRadius: "50%",
              backgroundColor: "white",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
              display: "flex",
              flexDirection: "column", // Stack items vertically
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            {/* Exam Icon */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "#E3F2FD",
                borderRadius: "50%",
                width: 60,
                height: 60,
                mb: 1, // Space between image and text
              }}
            >
              <img
                src="/assets/unit.png"
                alt="unit-I"
                style={{ width: 40, height: 40 }}
              />
            </Box>

            {/* Text Inside the Circle */}
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#6A1B9A",
                textAlign: "center",
              }}
            >
              {Examtype} Examination
            </Typography>
          </Box>
<Box sx={{ width: "70%" }}>
  {data.map((item, index) => (
    <Box
      key={index}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        marginBottom: "20px",
        cursor: "pointer",
        opacity: 1,
        transition: "all 0.3s ease-in-out",
        backgroundColor: "#fff",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        padding: "16px",
        width: "100%",
        "&:hover": {
          transform: "translateY(-3px)",
          boxShadow:
            "0px 8px 16px rgba(0, 150, 255, 0.5), 0px 12px 24px rgba(255, 0, 150, 0.5)",
        },
      }}
      onClick={() => handleNavigation(item.route)}
    >
      <IconWrapper
        icon={item.icon}
        color={item.color}
        customStyles={item.iconStyles}
      />
      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
        {item.title}
      </Typography>
    </Box>
  ))}
</Box>
        </Card>
      </Box>
      <ToastContainer position="top-right" autoClose={2000} />
    </Card>
  );
};

export default ExaminationMiniDashboard;